import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from './popover/popover.component';
import { PopoverModule as PrimePopoverModule } from 'primeng/popover';

@NgModule({
  declarations: [PopoverComponent],
  imports: [CommonModule, PrimePopoverModule],
  exports: [PopoverComponent],
})
export class PopoverModule {}
